import getObject from '../../../Common/get';

export let getFilteredMaintenance = async(type) => {
    let maintenances=[];
    let models=[];
	
    switch(type) {
        case process.env.REACT_APP_MANAGEMENT_EGT:
			let energetic = await getObject("certificates/energeticos/get", null, null);
			maintenances.push({
				code: process.env.REACT_APP_MANAGEMENT_EGT,
				data: energetic.data.respuesta
			});
            break;
        case process.env.REACT_APP_MANAGEMENT_EXT:
			let exeption = await getObject("certificates/retenciones/get", null, null);
			maintenances.push({
				code: process.env.REACT_APP_MANAGEMENT_EXT,
				data: exeption.data.respuesta
			});
            break;
        case process.env.REACT_APP_MANAGEMENT_RT:
			let index = await getObject("medidas/indices/get/all", null, null);
			maintenances.push({
				code: process.env.REACT_APP_MANAGEMENT_RT,
				data: index.data.respuesta
			});
            break;
    }

    if(maintenances != null && maintenances.length > 0) {
        maintenances[0].data.forEach(value => {
                let model = {
                    Id: value.Id,
                    Nombre: value.Nombre,
                    UsuarioInsercion: value.UsuarioInsercion,
                    UsuarioModificacion: value.UsuarioModificacion,
                    FechaInsercion: value.FechaInsercion,
                    Type: type
                }
    
                models.push(model);
        }); 
    }
    
    return new Promise((resolve, reject) => { 
        (models != null)
         ? resolve(models)
         : resolve([]);
    })
}